/** Funkce bez návratové hodnoty vyvolávající side effect */
export type Procedure = (...args: any[]) => void;

/**
 * Vytvoří funkci na níž bude při volání aplikován zadaný _debounce_
 * @param callback Obalovaná funkce
 * @param debounceMs Délka _debounce_ v milisekundách
 *
 * Inspirováno balíčkem ts-debounce
 * @link https://github.com/chodorowicz/ts-debounce
 */
export function debounce<T extends Procedure>(
    callback: T,
    debounceMs: number,
): (this: ThisParameterType<T>, ...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    return function(this: ThisParameterType<T>, ...args: Parameters<T>) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const doLater = function() {
            timeoutId = undefined;
            callback.apply(context, args);
        };

        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(doLater, debounceMs);
    };
}
